import { fetchTransfers } from '@/lib/api';

export default {
  state: {
    transfers: {},
    loading: false,
  },

  getters: {
    isLoadingTransfers(state) {
      return state.loading;
    },
    transfers(state) {
      return state.transfers;
    },
  },

  mutations: {
    setLoadingTransfers(state, loading) {
      state.loading = loading;
    },
    updateTransfers(state, transfers) {
      state.transfers = transfers;
    },
  },

  actions: {
    async fetchTransfers({ commit }, { clientId, date }) {
      commit('setLoadingTransfers', true);
      const transfers = await fetchTransfers.execute(clientId, date);
      commit('updateTransfers', transfers);
      commit('setLoadingTransfers', false);
      return transfers;
    },
  },
};
